// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/images/chart/bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circleGridContainer {
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  margin: 0.75rem auto;
  width: 450px;
  height: 450px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: cover;
}
@media (max-width: 576px) {
  .circleGridContainer {
    width: 380px;
    height: 380px;
  }
}
.circleGridContainer .chartContainer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: 2.8rem;
}
.circleGridContainer .chartContainer .quarterCircle1 {
  width: 175px;
  height: 175px;
  border-top-left-radius: 170px;
  box-sizing: border-box;
  color: white;
  padding-right: 0.5rem;
  padding-top: 1.5rem;
  position: relative;
  left: -0.5rem;
}
@media (max-width: 576px) {
  .circleGridContainer .chartContainer .quarterCircle1 {
    padding-top: 0;
    width: 150px;
    height: 150px;
  }
}
.circleGridContainer .chartContainer .quarterCircle1 > p {
  font-size: 0.6rem;
  display: inline-block;
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2rem;
  text-align: right;
  padding-right: 0.1rem;
}
@media (max-width: 576px) {
  .circleGridContainer .chartContainer .quarterCircle1 > p {
    width: 80px;
  }
}
.circleGridContainer .chartContainer .quarterCircle1 > p:nth-child(2) {
  margin-right: 0.5rem;
}
.circleGridContainer .chartContainer .quarterCircle1 > p:nth-child(3) {
  margin-right: 1rem;
}
.circleGridContainer .chartContainer .quarterCircle1 > p:nth-child(4) {
  margin-right: 1.5rem;
}
.circleGridContainer .chartContainer .quarterCircle1 > p:nth-child(5) {
  margin-right: 2rem;
}
.circleGridContainer .chartContainer .quarterCircle2 {
  width: 175px;
  height: 175px;
  border-top-right-radius: 170px;
  box-sizing: border-box;
  color: white;
  padding-right: 1.5rem;
  padding-top: 1.5rem;
  text-align: right;
  position: relative;
  right: -0.5rem;
}
@media (max-width: 576px) {
  .circleGridContainer .chartContainer .quarterCircle2 {
    padding-top: 0;
    width: 150px;
    height: 150px;
  }
}
.circleGridContainer .chartContainer .quarterCircle2 > p {
  font-size: 0.6rem;
  display: inline-block;
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2rem;
  text-align: right;
  padding-right: 0.1rem;
}
@media (max-width: 576px) {
  .circleGridContainer .chartContainer .quarterCircle2 > p {
    width: 80px;
  }
}
.circleGridContainer .chartContainer .quarterCircle2 > p:nth-child(1) {
  margin-right: 3.6rem;
}
.circleGridContainer .chartContainer .quarterCircle2 > p:nth-child(2) {
  margin-right: 2.5rem;
}
.circleGridContainer .chartContainer .quarterCircle2 > p:nth-child(3) {
  margin-right: 1.8rem;
}
.circleGridContainer .chartContainer .quarterCircle2 > p:nth-child(4) {
  margin-right: 1rem;
}
.circleGridContainer .chartContainer .quarterCircle3 {
  width: 175px;
  height: 175px;
  border-bottom-right-radius: 170px;
  box-sizing: border-box;
  color: white;
  padding-top: 1rem;
  padding-right: 0.875rem;
  position: relative;
  left: 0.5rem;
  top: 0.5rem;
}
@media (max-width: 576px) {
  .circleGridContainer .chartContainer .quarterCircle3 {
    padding-top: 0;
    width: 150px;
    height: 150px;
  }
}
.circleGridContainer .chartContainer .quarterCircle3 > p {
  font-size: 0.6rem;
  display: inline-block;
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2rem;
  text-align: right;
  padding-right: 0.1rem;
}
@media (max-width: 576px) {
  .circleGridContainer .chartContainer .quarterCircle3 > p {
    width: 80px;
  }
}
.circleGridContainer .chartContainer .quarterCircle3 > p:nth-child(2) {
  margin-right: 1rem;
}
.circleGridContainer .chartContainer .quarterCircle3 > p:nth-child(3) {
  margin-right: 1.5rem;
}
.circleGridContainer .chartContainer .quarterCircle3 > p:nth-child(4) {
  margin-right: 2rem;
}
.circleGridContainer .chartContainer .quarterCircle3 > p:nth-child(5) {
  margin-right: 3.5rem;
}
.circleGridContainer .chartContainer .quarterCircle4 {
  width: 175px;
  height: 175px;
  border-bottom-left-radius: 170px;
  box-sizing: border-box;
  color: white;
  padding-right: 0.5rem;
  padding-top: 1rem;
  text-align: right;
  position: relative;
  right: 0.5rem;
  top: 0.5rem;
}
@media (max-width: 576px) {
  .circleGridContainer .chartContainer .quarterCircle4 {
    padding-top: 0;
    width: 150px;
    height: 150px;
  }
}
.circleGridContainer .chartContainer .quarterCircle4 > p {
  font-size: 0.6rem;
  display: inline-block;
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2rem;
  text-align: right;
  padding-right: 0.1rem;
}
@media (max-width: 576px) {
  .circleGridContainer .chartContainer .quarterCircle4 > p {
    width: 80px;
  }
}
.circleGridContainer .chartContainer .quarterCircle4 > p:nth-child(1) {
  margin-right: 3rem;
}
.circleGridContainer .chartContainer .quarterCircle4 > p:nth-child(2) {
  margin-right: 2rem;
}
.circleGridContainer .chartContainer .quarterCircle4 > p:nth-child(3) {
  margin-right: 1.5rem;
}
.circleGridContainer .chartContainer .quarterCircle4 > p:nth-child(4) {
  margin-right: 1rem;
}
.circleGridContainer .circleBox {
  display: flex;
  width: 81px;
  height: 81px;
  border-radius: 40px;
  align-items: center;
  justify-content: center;
  background-color: white;
  position: absolute;
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/components/ResutTest/JobGroups/Circle/circle.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,YAAA;EACA,aAAA;EACA,oEAAA;EACA,sBAAA;AACJ;AACI;EAXJ;IAYQ,YAAA;IACA,aAAA;EAEN;AACF;AACI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AACR;AACQ;EACI,YAAA;EACA,aAAA;EACA,6BAAA;EAGA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AACZ;AACY;EAbJ;IAcQ,cAAA;IACA,YAAA;IACA,aAAA;EAEd;AACF;AACQ;EACI,iBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AACZ;AACY;EAXJ;IAYQ,WAAA;EAEd;AACF;AACQ;EACI,oBAAA;AACZ;AAEQ;EACI,kBAAA;AAAZ;AAGQ;EACI,oBAAA;AADZ;AAIQ;EACI,kBAAA;AAFZ;AAKQ;EACI,YAAA;EACA,aAAA;EACA,8BAAA;EAGA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAHZ;AAKY;EAdJ;IAeQ,cAAA;IACA,YAAA;IACA,aAAA;EAFd;AACF;AAKQ;EACI,iBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AAHZ;AAKY;EAXJ;IAYQ,WAAA;EAFd;AACF;AAKQ;EACI,oBAAA;AAHZ;AAMQ;EACI,oBAAA;AAJZ;AAOQ;EACI,oBAAA;AALZ;AAQQ;EACI,kBAAA;AANZ;AASQ;EACI,YAAA;EACA,aAAA;EACA,iCAAA;EAGA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAPZ;AASY;EAdJ;IAeQ,cAAA;IACA,YAAA;IACA,aAAA;EANd;AACF;AAUQ;EACI,iBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AARZ;AAUY;EAXJ;IAYQ,WAAA;EAPd;AACF;AAUQ;EACI,kBAAA;AARZ;AAWQ;EACI,oBAAA;AATZ;AAYQ;EACI,kBAAA;AAVZ;AAaQ;EACI,oBAAA;AAXZ;AAeQ;EACI,YAAA;EACA,aAAA;EACA,gCAAA;EAGA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;AAbZ;AAeY;EAfJ;IAgBQ,cAAA;IACA,YAAA;IACA,aAAA;EAZd;AACF;AAgBQ;EACI,iBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AAdZ;AAgBY;EAXJ;IAYQ,WAAA;EAbd;AACF;AAgBQ;EACI,kBAAA;AAdZ;AAiBQ;EACI,kBAAA;AAfZ;AAkBQ;EACI,oBAAA;AAhBZ;AAmBQ;EACI,kBAAA;AAjBZ;AAqBI;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAnBR","sourcesContent":[".circleGridContainer {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    position: relative;\n    margin: 0.75rem auto;\n    width: 450px;\n    height: 450px;\n    background: url('../../../../assets/images/chart/bg.png') no-repeat center;\n    background-size: cover;\n\n    @media (max-width: 576px ) {\n        width: 380px;\n        height: 380px;\n    }\n\n\n    .chartContainer {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        position: relative;\n        top: 2.8rem;\n\n        .quarterCircle1 {\n            width: 175px;\n            height: 175px;\n            border-top-left-radius: 170px;\n            -webkit-box-sizing: border-box;\n            -moz-box-sizing: border-box;\n            box-sizing: border-box;\n            color: white;\n            padding-right: 0.5rem;\n            padding-top: 1.5rem;\n            position: relative;\n            left: -0.5rem;\n\n            @media (max-width: 576px ) {\n                padding-top: 0;\n                width: 150px;\n                height:  150px;\n            }\n        }\n\n        .quarterCircle1 > p {\n            font-size: 0.6rem;\n            display: inline-block;\n            width: 100px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            line-height: 1.2rem;\n            text-align: right;\n            padding-right: 0.1rem;\n\n            @media (max-width: 576px ) {\n                width: 80px;\n            }\n        }\n\n        .quarterCircle1 > p:nth-child(2) {\n            margin-right: 0.5rem;\n        }\n\n        .quarterCircle1 > p:nth-child(3) {\n            margin-right: 1rem;\n        }\n\n        .quarterCircle1 > p:nth-child(4) {\n            margin-right: 1.5rem;\n        }\n\n        .quarterCircle1 > p:nth-child(5) {\n            margin-right: 2rem;\n        }\n\n        .quarterCircle2 {\n            width: 175px;\n            height: 175px;\n            border-top-right-radius: 170px;\n            -webkit-box-sizing: border-box;\n            -moz-box-sizing: border-box;\n            box-sizing: border-box;\n            color: white;\n            padding-right: 1.5rem;\n            padding-top: 1.5rem;\n            text-align: right;\n            position: relative;\n            right: -0.5rem;\n\n            @media (max-width: 576px ) {\n                padding-top: 0;\n                width: 150px;\n                height:  150px;\n            }\n        }\n\n        .quarterCircle2 > p {\n            font-size: 0.6rem;\n            display: inline-block;\n            width: 100px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            line-height: 1.2rem;\n            text-align: right;\n            padding-right: 0.1rem;\n\n            @media (max-width: 576px ) {\n                width: 80px;\n            }\n        }\n\n        .quarterCircle2 > p:nth-child(1) {\n            margin-right: 3.6rem;\n        }\n\n        .quarterCircle2 > p:nth-child(2) {\n            margin-right: 2.5rem;\n        }\n\n        .quarterCircle2 > p:nth-child(3) {\n            margin-right: 1.8rem;\n        }\n\n        .quarterCircle2 > p:nth-child(4) {\n            margin-right: 1rem;\n        }\n\n        .quarterCircle3 {\n            width: 175px;\n            height: 175px;\n            border-bottom-right-radius: 170px;\n            -webkit-box-sizing: border-box;\n            -moz-box-sizing: border-box;\n            box-sizing: border-box;\n            color: white;\n            padding-top: 1rem;\n            padding-right: 0.875rem;\n            position: relative;\n            left: 0.5rem;\n            top: 0.5rem;\n\n            @media (max-width: 576px ) {\n                padding-top: 0;\n                width: 150px;\n                height:  150px;\n            }\n        }\n\n\n        .quarterCircle3 > p {\n            font-size: 0.6rem;\n            display: inline-block;\n            width: 100px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            line-height: 1.2rem;\n            text-align: right;\n            padding-right: 0.1rem;\n\n            @media (max-width: 576px ) {\n                width: 80px;\n            }\n        }\n\n        .quarterCircle3 > p:nth-child(2) {\n            margin-right: 1rem;\n        }\n\n        .quarterCircle3 > p:nth-child(3) {\n            margin-right: 1.5rem;\n        }\n\n        .quarterCircle3 > p:nth-child(4) {\n            margin-right: 2rem;\n        }\n\n        .quarterCircle3 > p:nth-child(5) {\n            margin-right: 3.5rem;\n        }\n\n\n        .quarterCircle4 {\n            width: 175px;\n            height: 175px;\n            border-bottom-left-radius: 170px;\n            -webkit-box-sizing: border-box;\n            -moz-box-sizing: border-box;\n            box-sizing: border-box;\n            color: white;\n            padding-right: 0.5rem;\n            padding-top: 1rem;\n            text-align: right;\n            position: relative;\n            right: 0.5rem;\n            top: 0.5rem;\n\n            @media (max-width: 576px ) {\n                padding-top: 0;\n                width: 150px;\n                height:  150px;\n            }\n        }\n\n\n        .quarterCircle4 > p {\n            font-size: 0.6rem;\n            display: inline-block;\n            width: 100px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            line-height: 1.2rem;\n            text-align: right;\n            padding-right: 0.1rem;\n\n            @media (max-width: 576px ) {\n                width: 80px;\n            }\n        }\n\n        .quarterCircle4 > p:nth-child(1) {\n            margin-right: 3rem;\n        }\n\n        .quarterCircle4 > p:nth-child(2) {\n            margin-right: 2rem;\n        }\n\n        .quarterCircle4 > p:nth-child(3) {\n            margin-right: 1.5rem;\n        }\n\n        .quarterCircle4 > p:nth-child(4) {\n            margin-right: 1rem;\n        }\n    }\n\n    .circleBox {\n        display: flex;\n        width: 81px;\n        height: 81px;\n        border-radius: 40px;\n        align-items: center;\n        justify-content: center;\n        background-color: white;\n        position: absolute;\n        z-index: 10;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
